module.exports = __webpack_public_path__ + "img/cur14.12b64303.png";